import { render } from "./RuiDropdown.vue?vue&type=template&id=6f732851&scoped=true"
import script from "./RuiDropdown.vue?vue&type=script&lang=ts"
export * from "./RuiDropdown.vue?vue&type=script&lang=ts"

import "./RuiDropdown.vue?vue&type=style&index=0&id=6f732851&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f732851"

export default script